import { render, staticRenderFns } from "./RazorpayTransactions.vue?vue&type=template&id=0354de3b&scoped=true"
import script from "./RazorpayTransactions.vue?vue&type=script&lang=js"
export * from "./RazorpayTransactions.vue?vue&type=script&lang=js"
import style0 from "./RazorpayTransactions.vue?vue&type=style&index=0&id=0354de3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0354de3b",
  null
  
)

export default component.exports